/**
 * Created by USER on 18/6/7.
 */
import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import {Icon, Dropdown, Menu, message} from 'antd';
import ImgList from '../images/img';
import {changeBarState} from '../redux/actions/headerbar_action';
import httpClient from '../swagger/download_swagger';

const { client } = httpClient;

class Download extends Component {
  constructor(props) {
    super(props);
    this.state = {
      downloadList: [
        {index: 1, system: 'mac', bit: false, type: this.props.t('download_type_mac')},
        {index: 2, system: 'windows', bit: 64, type: this.props.t('download_type_windows')},
      ],
      version: null
    };
  }
  componentWillMount() {
    this.props.dispatch(changeBarState('download'));
  }

  componentDidMount() {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 500);
    const {platform} = navigator;
    const {downloadList} = this.state;
    client.then((oclient) => { // 请求当前下载的版本号
      oclient.apis.app.get_app_system_latest({
        system: 'mac',
        bit: false
      }).then((res) => {
        if (res.status === 200) {
          this.setState({
            version: res.obj.data.version
          });
        } else {
          message.error(this.props.t('request_error'));
        }
      }).catch(() => message.error(this.props.t('request_error')));
    }).catch(() => {});
    if (platform.indexOf('Mac') >= 0) { // 判断设备的系统以及型号，点击下载时下载相应的版本
      downloadList.splice(0, 1);
      this.setState({
        downloadList
      });
    } else {
      downloadList.splice(1, 1);
      this.setState({
        downloadList
      });
    }
  }

  downloadAPP(system, bit) { // 不同的设备下载不同的版本
    const obj = {system, bit};
    if (!bit) delete obj.bit;
    client.then((oclient) => {
      oclient.apis.app.get_app_system_latest(obj).then((res) => {
        if (res.status === 200) {
          // 下载的方法
          const a = document.createElement('a');
          a.setAttribute('href', res.obj.data.url);
          a.setAttribute('download', 'LUBANSO');
          document.body.appendChild(a);
          a.click();
          if (a.remove) {
            a.remove();
          } else {
            a.removeNode();
          }
          if (window.ga) {
            window.ga('send', 'event', {
              eventCategory: 'App',
              eventAction: 'download',
            });
          }
        } else {
          message.error(this.props.t('request_error'))
        }
      }).catch(() => message.error(this.props.t('request_error')));
    }).catch(() => {});
  }

  download() { // 下载app 判断设备
    const {platform} = navigator;
    if (platform.indexOf('Mac') >= 0) {
      this.downloadAPP('mac', false);
    } else {
      this.downloadAPP('windows', 64);
    }
  }

  goToSupport() { // 跳转到视频教程页面
    window.open('https://support.lubanso.com/hc/zh-cn#360000859634');
  }

  componentWillReceiveProps(nextProps){
    if (this.props.appBarReducer.language !== nextProps.appBarReducer.language) {
      const {platform} = navigator;
      if (platform.indexOf('Mac') >= 0) { // 判断设备的系统以及型号，点击下载时下载相应的版本
        this.setState({
          downloadList: [{index: 2, system: 'windows', bit: 64, type: this.props.t('download_type_windows')}]
        })
      } else {
        this.setState({
          downloadList: [{index: 1, system: 'mac', bit: false, type: this.props.t('download_type_mac')}]
        })
      }
    }
  }
  render() {
    const menu = (
      <Menu className="app_menu">
        {
          this.state.downloadList.map(item =>
            <Menu.Item key={item.index}>
              <div
                onClick={() => this.downloadAPP(item.system, item.bit)}
                onKeyPress={() => this.downloadAPP(item.system, item.bit)}
              >
                {item.type}
              </div>
            </Menu.Item>)
        }
      </Menu>
    );
    const { t } = this.props;
    const {version} = this.state;
    return (
      <div className="download">
        <div className="download_head">
          <div className="download_title">
            <div className="app_download">
              <div className="app_download_title">{t('download_title')}</div>
              <div className="app_download_advantage">{t('download_advantage')}</div>
              <div className="app_download_button">
                <div
                  className="download_button"
                  onClick={() => this.download()}
                  onKeyPress={() => this.download()}
                >
                  {t('download_button')}
                </div>
                <div className="download_button_dropDown">
                  <Dropdown overlay={menu} trigger={['click']} placement="bottomLeft">
                    <Icon type="down" />
                  </Dropdown>
                </div>
              </div>
              <div className="app_download_notice">{t('download_notice1')}{version}，{t('download_notice2')}</div>
            </div>
          </div>
          <div className="download_img">
            <img src={ImgList.img.download} alt="lubanso" />
          </div>
        </div>
        <div className="web_app_advantage">
          <div className="single_web_app_advantage">
            <div><i className="icon iconfont icon icon-gw-3"/></div>
            <span className="single_web_app_advantage_title">{t('web_app_advantage_friendly')}</span>
            <span className="single_web_app_advantage_notice">{t('web_app_advantage_friendly1')}</span>
            <span className="single_web_app_advantage_notice">{t('web_app_advantage_friendly2')}</span>
          </div>
          <div className="single_web_app_advantage">
            <div><i className="icon iconfont icon icon-gw-4"/></div>
            <span className="single_web_app_advantage_title">{t('web_app_advantage_efficient')}</span>
            <span className="single_web_app_advantage_notice">{t('web_app_advantage_efficient1')}</span>
            <span className="single_web_app_advantage_notice">{t('web_app_advantage_efficient2')}</span>
          </div>
          <div className="single_web_app_advantage">
            <div><i className="icon iconfont icon icon-gw-5"/></div>
            <span className="single_web_app_advantage_title">{t('web_app_advantage_platform')}</span>
            <span className="single_web_app_advantage_notice">{t('web_app_advantage_platform1')}</span>
            <span className="single_web_app_advantage_notice">Mac OS</span>
          </div>
        </div>
        <div className="web_app_details">
          <div>
            <div className="web_app_details_img">
              <img src={t('language') === 'zh' ? ImgList.img.webAppDetails1 : ImgList.img.webAppDetailsEN1} alt="lubanso" />
            </div>
            <div className="web_app_details_content">
              <div>
                <h2>{t('download_app_overview')}</h2>
                <span>{t('download_app_overview1')}</span>
                <span>{t('download_app_overview2')}</span>
                <span>{t('download_app_overview3')}</span>
              </div>
            </div>
          </div>
          <div className="web_app_details_right">
            <div className="web_app_details_content web_app_details_content_web">
              <div>
                <h2>{t('download_app_trading')}</h2>
                <span>{t('download_app_trading1')}</span>
                <span>{t('download_app_trading2')}</span>
              </div>
            </div>
            <div className="web_app_details_img">
              <img src={t('language') === 'zh' ? ImgList.img.webAppDetails3 : ImgList.img.webAppDetailsEN3} alt="lubanso" />
            </div>
            <div className="web_app_details_content web_app_details_content_mobile">
              <div>
                <h2>{t('download_app_trading')}</h2>
                <span>{t('download_app_trading1')}</span>
                <span>{t('download_app_trading2')}</span>
              </div>
            </div>
          </div>
          <div>
            <div className="web_app_details_img">
              <img src={t('language') === 'zh' ? ImgList.img.webAppDetails2 : ImgList.img.webAppDetailsEN2} alt="lubanso" />
            </div>
            <div className="web_app_details_content">
              <div>
                <h2>{t('download_app_management')}</h2>
                <span>{t('download_app_management1')}</span>
                <span>{t('download_app_management2')}</span>
                <span>{t('download_app_management3')}</span>
              </div>
            </div>
          </div>
        </div>
        <div className="web_app_feature">
          <div>
            <div className="single_app_feature">
              <div><i className="icon iconfont icon-k5" /></div>
              <div className="single_app_feature_content">
                <span>{t('download_app_feature_1x1')}</span>
                <span>{t('download_app_feature_1x1_1')}</span>
                <span>{t('download_app_feature_1x1_2')}</span>
              </div>
            </div>
            <div className="single_app_feature">
              <div><i className="icon iconfont icon-k3" /></div>
              <div className="single_app_feature_content">
                <span>{t('download_app_feature_1x2')}</span>
                <span>{t('download_app_feature_1x2_1')}</span>
                <span>{t('download_app_feature_1x2_2')}</span>
              </div>
            </div>
          </div>
          <div>
            <div className="single_app_feature">
              <div><i className="icon iconfont icon-k" /></div>
              <div className="single_app_feature_content">
                <span>{t('download_app_feature_2x1')}</span>
                <span>{t('download_app_feature_2x1_1')}</span>
                <span>{t('download_app_feature_2x1_2')}</span>
              </div>
            </div>
            <div className="single_app_feature">
              <div><i className="icon iconfont icon-k4" /></div>
              <div className="single_app_feature_content">
                <span>{t('download_app_feature_2x2')}</span>
                <span>{t('download_app_feature_2x2_1')}</span>
                <span>{t('download_app_feature_2x2_2')}</span>
              </div>
            </div>
          </div>
          <div>
            <div className="single_app_feature">
              <div><i className="icon iconfont icon-k2" /></div>
              <div className="single_app_feature_content">
                <span>{t('download_app_feature_3x1')}</span>
                <span>{t('download_app_feature_3x1_1')}</span>
                <span>{t('download_app_feature_3x1_2')}</span>
              </div>
            </div>
            <div className="single_app_feature">
              <div><i className="icon iconfont icon-k1" /></div>
              <div className="single_app_feature_content">
                <span>{t('download_app_feature_3x2')}</span>
                <span>{t('download_app_feature_3x2_1')}</span>
                <span>{t('download_app_feature_3x2_2')}</span>
                <span>{t('download_app_feature_3x2_3')}</span>
              </div>
            </div>
          </div>
        </div>
        <div className="product_details_img video_tutorial">
          <div>
            <div>
              <h3>{t('download_video_tutorial')}</h3>
              <p onClick={() => this.goToSupport()}>{t('download_video_tutorial_notice')}</p>
            </div>
          </div>
          <img src={ImgList.img.video} alt="lubanso" />
        </div>
        <div className="product_details_img product_details_img_back_ground product_details_img_mobileApp">
          <div>
            <h2>{t('product_details_mobile_app')}</h2>
            <h3>{t('product_details_mobile_app1')}</h3>
          </div>
          <img src={ImgList.img.productImgFuture} alt="lubanso" />
        </div>
      </div>
    );
  }
}

function select(state) {
  return {
    appBarReducer: state.appBarReducer
  };
}

const DownloadConnected = connect(select)(Download);

export default translate('translations')(DownloadConnected);
